<template>
  <!-- 子活动 -->
  <div class="detail-series">
    <div class="detail-details show-box" v-if="series.length" style="margin-top: 0;padding-top: 15px">
      <ul class="show-list clearfix">
        <li class="" v-for="(item,i) in series" style="margin-bottom: 20px">
          <div v-if="new Date(item.end_time).getTime() / 1  - new Date().getTime() > 0 && new Date(item.start_time).getTime() / 1 - new Date().getTime() < 0">
            <!--子活动报名-->
            <router-link v-if="item.url_type && item.url_type == '2'" tag="a"
                         :to="{name:'Notice',params: {id: item.id}}">

              <div class="pic-box">
                <img v-if="item.playbill" :src="item.playbill.playbill_h5+'?p=3&o=2&w=350&h=197'" alt=""/>
              </div>
              <h6>{{item.title, 20 | ellipsis}}</h6>
            </router-link>
            <!--子活动投票-->
            <router-link v-if="item.url_type && item.url_type == '3'" tag="a"
                         :to="{name:'list_vote',params: {id: item.id,active: 0}}">

              <div class="pic-box">
                <img v-if="item.playbill" :src="item.playbill.playbill_h5+'?p=3&o=2&w=350&h=197'" alt=""/>
              </div>
              <h6>{{item.title,20|ellipsis}}</h6>
            </router-link>
            <router-link v-if="item.url_type && item.url_type != '3'&& item.url_type != '2'" tag="a"
                         :to="{name:'Detail',params: {id: item.id}}">
              <div class="pic-box">
                <img v-if="item.playbill" :src="item.playbill.playbill_h5+'?p=3&o=2&w=350&h=197'" alt=""/>
              </div>
              <h6>{{item.title,20|ellipsis}}</h6>
            </router-link>
          </div>
          <div v-else>
            <router-link tag="a" :to="{name:'Detail',params: {id: item.id}}">
              <div class="pic-box">
                <img v-if="item.playbill" :src="item.playbill.playbill_h5+'?p=3&o=2&w=350&h=197'" alt=""/>
              </div>
              <h6>{{item.title, 20 | ellipsis}}</h6>
            </router-link>
          </div>

<!--          <router-link-->
<!--            v-if="new Date(item.end_time).getTime() / 1  - new Date().getTime() > 0 && new Date(item.start_time).getTime() / 1 - new Date().getTime() < 0"-->
<!--            tag="a" class="detail-details-a"-->
<!--            :to="{name:'Notice',params: {id: item.id}}">-->
<!--            马上参与-->
<!--          </router-link>-->

          <a
            v-if="new Date(item.end_time).getTime() / 1  - new Date().getTime() > 0 && new Date(item.start_time).getTime() / 1 - new Date().getTime() < 0"
            class="detail-details-a"
            @click.prevent="joinSeries(item)">
            马上参与
          </a>

          <router-link tag="a" v-if="new Date(item.end_time).getTime() / 1  - new Date().getTime() < 0" :to="{name:'Detail',params: {id: item.id}}"
             class="detail-details-a" href="javascript:void(0);">
            活动结束
          </router-link>

          <router-link tag="a" v-if="new Date(item.start_time).getTime() / 1 - new Date().getTime() > 0" class="detail-details-a" :to="{name:'Detail',params: {id: item.id}}"
             href="javascript:void(0);">
            即将开始
          </router-link>

        </li>
      </ul>
      <p class="seriesAll" style="color:#cf5454;font-size: 14px;margin-top: -10px" @click="seriesAll">
        加载更多
      </p>
    </div>
  </div>

</template>

<script>
  export default {
    name: "series",
    props: [
      "detailsTxte",
      "twoNumbers",
    ],
    data() {
      return {
        series: [],        // 系列
        seriesPage: 0,
        ID: '',
        sort: 'desc',
      }
    },
    methods: {
      seriesAll() {
        var that = this;
        that.seriesPage = ++that.seriesPage;
        var activitie = {
          parent_id: that.ID,
          version: 2,
          page: that.seriesPage,
          pagesize: 10,
          sort: that.sort
        };
        that.$http.get(API.GetActivities, {params: activitie})
          .then(function (res) {
            if (res.code == 0) {
              that.seriesName = 'true'
              for (var i = 0; i < res.data.length; i++) {
                that.series.push(res.data[i]);
              }
              that.$nextTick(function () {
                if (res.total == that.series.length) {
                  $('.seriesAll').hide();
                }
                var banWimg = $('.pic-box').width();
                var banHimg = Math.ceil($('.pic-box').width() / 16 * 9);
                $('.pic-box img').css({width: banWimg, height: banHimg, visibility: 'visible'});
              })

            }
          })
      },
      joinSeries:function(item){
        //console.log(item);
        var that=this;
        if (that.loginFn()) {
          console.log('判断是否登录-已登录')
        } else {
          $('#login_Alert').modal('show');
          // that.$router.push({name: 'login_Quick'})
          return false;
        }
        that.$http.get(API.IsJoin, {params: {activity_id: item.id}})
          .then(function (res) {
            console.log(res);
            if (res.code == 0) {
              if (res.data.isJoin == 0) {
                that.$router.push({name: 'Notice', params: {id: item.id}})
              } else if(res.data.child_sign&&res.data.child_sign.is_show=="1"){
                // 只能参与一个子活动
                $("#msg_Alert").find(".info-mess").html(res.data.child_sign.title);
                $("#msg_Alert").modal();
              }else{
                that.$router.push({name: 'Revise', params: {id: item.id,form_id:0}});
                return false;
              }
            }
          })
      }
    },
    created: function () {
      var that = this;
      var pageConfig = that.detailsTxte.page_config;
      that.ID = this.$route.params.id;
      if (that.detailsTxte.type == 1) {
        if (pageConfig && pageConfig.display_order) {
          that.sort = pageConfig.display_order;
        }
        that.seriesAll()
      }
    },
    mounted: function () {
      // 操作DOM
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/detailtmplate/series.vue